import axios from 'axios'
import { API_URL } from '../../../../constants'
import { IEmployeeProfileRes } from './getEmployeeProfile'

export const attachMerchant = (employeeId: number, merchantId: number) =>
  axios.post<IEmployeeProfileRes>(
    `${API_URL}/api/internal/employee/${employeeId}/merchants/${merchantId}`
  )

export const detachMerchant = (employeeId: number, merchantId: number) =>
  axios.delete<IEmployeeProfileRes>(
    `${API_URL}/api/internal/employee/${employeeId}/merchants/${merchantId}`
  )
